<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card v-can="'view-sample-order'" v-if="!is_on_create" title="SAMPLE ORDERS" >
          <template slot="actions">
            <vs-button v-can="'create-sample-order'" @click="onClickCreateNewOrder" class="mr-4" color="primary" type="filled">Create new order</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-can="'view-sample-order'" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table  :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="15%" sort-key="created_at">DATE/TIME</vs-th>
                <vs-th width="15%" sort-key="sample_order_code">ORDER CODE</vs-th>
                <vs-th width="40%" >FINISHED PRODUCTS</vs-th>
                <vs-th width="15%" >STATUS</vs-th>
                <vs-th width="15%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td :data="data[indextr].sample_order_code">
                    {{ data[indextr].sample_order_code}}
                  </vs-td>


                  <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulation_items.length > 0" v-for="item in data[indextr].formulation_items" :key="item + '' + Math.random()">
                      <a>{{ item.name }}</a> ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="projectBriefColorFactory(tr.status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip v-can="'view-sample-order'" class="mr-2" text="View Order" position="left">
                        <vs-button
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'edit-sample-order'" class="mr-2" text="Update Order" position="left">
                        <vs-button v-if="tr.status.id === 1" @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <div class="con-btns-user flex items-center justify-between">
                        <div class="con-userx flex items-center justify-start">
<!--                          <vs-avatar :badge="tr.id" size="45px" :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`" />-->
<!--                          <span>{{ tr.name }}</span>-->
                        </div>
                        <div class="flex mb-4">
                          <vs-button v-if="[1].includes(tr.status.id)" @click="onClickStatusChangeConfirm(tr.id, 'cancel')" type="border" size="small" icon-pack="feather" icon="icon-x" color="danger" class="mr-2">Cancel Order</vs-button>
                        </div>
                      </div>

                      <div class="vx-row mb-1">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                          <vs-list>
                            <vs-list-header title="Address"></vs-list-header>

                            <vs-list-item subtitle="Site Name" :title="tr.name ? tr.name : '-'"></vs-list-item>
                            <vs-list-item subtitle="Address Line 1" :title="tr.line1 ? tr.line1 : '-'"></vs-list-item>
                            <vs-list-item subtitle="Address Line 2" :title="tr.line2 ? tr.line2 : '-'"></vs-list-item>
                            <vs-list-item subtitle="Address Line 3" :title="tr.line3 ? tr.line3 : '-'"></vs-list-item>
                            <vs-list-item subtitle="Town/State" :title="tr.town_state ? tr.town_state : '-'"></vs-list-item>
                            <vs-list-item subtitle="Postal Code" :title="tr.post_code ? tr.post_code: '-'"></vs-list-item>
                            <vs-list-item subtitle="Country" :title="tr.country ? tr.country : '-'"></vs-list-item>

                            <vs-list-header title="Special Delivery Instructions"></vs-list-header>

                            <vs-list-item :subtitle="tr.delivery_instruction ? tr.delivery_instruction : '-'"></vs-list-item>
                          </vs-list>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                          <vs-list-header title="Finished products"></vs-list-header>
                          <span v-for="item in data[indextr].formulation_items" :key="item + '' + Math.random() ">
                            <div><vs-list-item :title="String(item.name)" :subtitle="`${item.quantity || 0} grams`"></vs-list-item></div>
                          </span>
                        </div>
                      </div>

                    </div>
                  </template>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-sample-order'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
        <customer-cart-list v-on:back="refreshData($event)" v-if="is_on_create"/>
      </div>
    </div>
    <update-customer-sample-order-pop-up ref="updateCustomerSampleOrderPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import UpdateCustomerSampleOrderPopUp from '@/components/popups/customer/sample-orders/UpdateCustomerSampleOrderPopUp'
  import CustomerCartList from './CustomerCartList'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        is_on_create: false
      }
    },
    components: {
      'v-select': vSelect,
      UpdateCustomerSampleOrderPopUp,
      CustomerCartList
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {},
    methods: {
      async refreshData () {
        this.is_on_create = false
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getListOfSamples(this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerSampleOrderPopUp.openPopup(id)
      },
      onClickCreateNewOrder() {
        this.is_on_create = true
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return '#f05945';
          case 4:
            return '#f58634';
          case 5:
            return '#206a5d';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerSampleOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.loadStaff()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      }

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
